import { useEffect } from 'react';
import { useUiStore } from '../store/uiStore';

export function ToastHost() {
  const { toasts, dismissToast } = useUiStore();

  useEffect(() => {
    if (toasts.length === 0) return;
    const timers = toasts.map((t) =>
      setTimeout(() => dismissToast(t.id), 4000),
    );
    return () => timers.forEach(clearTimeout);
  }, [toasts, dismissToast]);

  const color = {
    success: 'border-emerald-400 bg-emerald-950',
    error: 'border-rose-400 bg-rose-950',
    info: 'border-sky-400 bg-sky-950',
  };

  return (
    <div className="fixed bottom-4 right-4 z-50 flex w-80 flex-col gap-2">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`rounded-lg border px-4 py-3 text-sm shadow-lg ${color[t.kind]}`}
          role="status"
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
